import { locations } from '../data/locations.js';
import { storage } from '../app/storage.js';

const limit = 5;

class RecentLocs {
  async add(loc) {
    if (!loc.id) {
      return;
    }

    // Depromisify the list.
    this.#list = await this.get();

    // Update the list.
    let idx = this.#list.findIndex(i => i.id == loc.id);
    if (idx == -1) {
      this.#list.unshift(loc);
      this.#list.splice(limit);
    } else {
      this.#list.splice(idx, 1);
      this.#list.unshift(loc);
    }
    storage.set(
      'recentlocs',
      this.#list.map(loc => ({
        id: loc.id,
        name: loc.name,
        type: loc.type,
        subtype: loc.subtype,
        google_id: loc.google_id,
        lat: loc.lat,
        lng: loc.lng,
      }))
    );
  }

  get() {
    if (!this.#list) {
      let list = storage.get('recentlocs');
      let ids = list?.map(l => l.id);
      this.#list = Promise.resolve((ids && locations.byIds(ids)) || []).then(
        list => list.filter(loc => loc.id && loc.type)
      );
    }
    return this.#list;
  }

  search({ type }) {
    return Promise.resolve(this.get()).then(list =>
      list.filter(item => !type || item.type == type)
    );
  }

  #list;
}

export const recentLocs = new RecentLocs();
